import React, { useState, useEffect } from 'react';
import { academyAdminAPI } from '../../lib/academyApi';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Loader2, CreditCard } from 'lucide-react';

const statusColors = { initiated: 'bg-gray-100 text-gray-600', pending: 'bg-yellow-100 text-yellow-700', paid: 'bg-green-100 text-green-700', failed: 'bg-red-100 text-red-700', refunded: 'bg-orange-100 text-orange-700', expired: 'bg-gray-100 text-gray-500' };

const AcademyPayments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { academyAdminAPI.listPayments().then(r => setItems(r.data)).catch(()=>{}).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="p-8 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#F9B438]" /></div>;

  return (
    <div className="p-6 lg:p-8" data-testid="academy-payments-admin">
      <div className="mb-6"><h1 className="font-heading text-2xl font-bold text-[#1D1D1B]">Paiements</h1><p className="text-neutral-500 text-sm">{items.length} transaction(s)</p></div>
      {items.length === 0 ? (
        <div className="text-center py-16"><CreditCard className="w-12 h-12 text-neutral-300 mx-auto mb-3" /><p className="text-neutral-500">Aucune transaction pour le moment</p></div>
      ) : (
        <div className="space-y-3">
          {items.map(item => (
            <Card key={item.id}><CardContent className="p-4 flex items-center justify-between">
              <div>
                <p className="font-medium text-[#1D1D1B]">{item.metadata?.training_title || item.training_id}</p>
                <p className="text-sm text-neutral-500">{item.email} - {new Date(item.created_at).toLocaleDateString('fr-CA')}</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-bold text-[#1D1D1B]">{item.amount?.toFixed(2)} $ {item.currency?.toUpperCase()}</span>
                <Badge className={statusColors[item.payment_status] || 'bg-gray-100'}>{item.payment_status}</Badge>
              </div>
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default AcademyPayments;
